module.exports = __webpack_public_path__ + "img/sample-report-01@3x.c4d24298.png";